import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { productsAPI } from '../services/api';
import { useSettings } from '../context/SettingsContext';
import LazyImage from './LazyImage';

const DesktopShowcase = ({ products }) => {
  const navigate = useNavigate();
  const { resolveMediaUrl } = useSettings();
  const [introductions, setIntroductions] = useState([]);

  useEffect(() => {
    let mounted = true;
    const loadIntroductions = async () => {
      try {
        const res = await productsAPI.getProductIntroductions();
        const items = res?.data?.results;
        if (!mounted) return;
        setIntroductions(Array.isArray(items) ? items : []);
      } catch (_) {
        if (!mounted) return;
        setIntroductions([]);
      }
    };
    loadIntroductions();
    return () => { mounted = false; };
  }, []);

  const pickProductImage = (product) => {
    const candidates = [
      product?.main_image,
      product?.mainImage,
      product?.main_image_url,
      product?.mainImageUrl,
      product?.image,
      product?.thumbnail_url,
      product?.thumbnail,
      Array.isArray(product?.images)
        ? (typeof product.images[0] === 'string' ? product.images[0] : product.images[0]?.image)
        : null,
    ];
    for (const c of candidates) {
      const resolved = resolveMediaUrl(c);
      if (resolved) return resolved;
    }
    return null;
  };

  const showcase = products ? products.slice(0, 4) : [];
  const items = introductions.length > 0 ? introductions.slice(0, 4) : showcase;

  if (items.length === 0) return null;

  return (
    <div className="mb-20">
      <div className="flex items-center justify-between mb-8 px-4">
        <h2 className="text-3xl font-bold text-gray-900 border-r-4 border-kadolar-600 pr-4">معرفی محصولات</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-4 justify-items-center">
        {items.map((item, idx) => (
            <div 
                key={item.id || idx} 
                className="group cursor-pointer relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 bg-white w-full max-w-[230px] aspect-square"
                onClick={() => {
                    if (introductions.length > 0 && item?.slug) {
                      navigate(`/introductions/${item.slug}`);
                      return;
                    }
                    if (item?.id) navigate(`/product/${item.id}`);
                }}
            >
                <div className="absolute inset-0 bg-gray-100">
                    <LazyImage
                        src={introductions.length > 0 ? resolveMediaUrl(item?.main_image) : pickProductImage(item)}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                </div>
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-white font-bold text-sm mb-2 line-clamp-2">{item.title}</h3>
                    <button className="text-xs text-white/90 border border-white/30 bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full hover:bg-white/30 transition-colors">
                        مشاهده جزئیات
                    </button>
                </div>
            </div>
        ))}
      </div>
    </div>
  );
};

export default DesktopShowcase;
